import { Component, input, contentChild, computed, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'andor-settings-shell',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './settings-shell.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './settings-shell.scss',
})
export class SettingsShell {
  title = input('');

  /** Set by the parent on the element that fills the actions slot (e.g. <div #actions actions>). */
  private actionsRef = contentChild('actions');
  protected hasActions = computed(() => !!this.actionsRef());
}
